import { isRealDate, toInputDate } from './promoPrimitives';
import { getNationalOfferInfo, getOfferInfo } from './promoModel';

// Offer-level information stored on the appointment `offerInfos` (#23521) : the offer comment and the statement end date
// (#23445). A national offer keeps them on an offerInfo keyed like its comment (`saveOfferComment`), created on demand by
// the legacy commit ; a local offer on its own offerInfo.

/** `textHelper.removeTags` : never `false` for an empty comment (lesson 77, API 400). */
export const removeTags = (value) => (value === null || value === undefined || value === '' ? '' : String(value).replace(/(<([^>]+)>)/gi, ''));

export const offerInfoOf = (snapshot, ref) => (ref.offerKey ? getOfferInfo(snapshot, ref.offerKey) : getNationalOfferInfo(snapshot, ref.campaignId, ref.campaignOfferId));

export const offerComment = (snapshot, ref) => offerInfoOf(snapshot, ref)?.comment || '';

/** National offer comment (`saveOfferComment`, JS:2555) ; a local offer's internal comment goes through `applyLocalOfferComment`. */
export const applyOfferComment = (value) => ({ ok: true, offerInfo: { comment: removeTags(value) } });

/** Bounds of the statement end date (#23445 RG-04) : from the store end date (a local offer : its own end date) to the campaign end date. */
export function statementEndDateBounds(campaign, offerInfo) {
	return { min: campaign?.promoLocal ? offerInfo?.endDate : campaign?.dates?.storeEnd, max: campaign?.dates?.end };
}

/**
 * Statement end date change (`updateStatementEndDateHandler`, JS:3965) : an emptied field clears it, a date outside the
 * bounds is refused (`OfferStatementEndDateOutOfRange`, or `OfferDatesError` while a local offer has no end date).
 */
export function applyStatementEndDate(snapshot, campaign, ref, rawValue) {
	if (snapshot?.readonly && !snapshot?.isPrepa) return { ok: false, error: 'PromoReadonly' };
	const offerInfo = offerInfoOf(snapshot, ref);
	const bounds = statementEndDateBounds(campaign, offerInfo);
	const min = toInputDate(bounds.min);
	const max = toInputDate(bounds.max);
	if (rawValue && (!isRealDate(rawValue) || !min || rawValue < min || (max && rawValue > max))) {
		return min ? { ok: false, error: 'OfferStatementEndDateOutOfRange', params: [bounds.min, bounds.max] } : { ok: false, error: 'OfferDatesError' };
	}
	if (!offerInfo && !rawValue) return { ok: false, error: null };
	return { ok: true, offerInfo: { statementEndDate: rawValue ? new Date(rawValue) : null } };
}

export const statementEndDateValue = (snapshot, ref) => toInputDate(offerInfoOf(snapshot, ref)?.statementEndDate);
